<template>
  <div id="custom-online">
    <Breadcrumb></Breadcrumb>
    <!-- 产品定制_我的设计 -->

    <div class="form-body form-detail-wrap">
      <el-form label-width="100px" ref="form" :model="form">
        <div class="form-detail-content">
          <div class="item item1">
            <div class="step">
              <div class="number">1</div>
              <div>选择产品</div>
            </div>
            <div
              v-if="!showDetail"
              class="select-product"
              @click="handleSelectProduct"
            >
              <i class="el-icon-plus"></i>
              选择产品
            </div>
            <div v-if="showDetail" class="select-product-content">
              <div class="select-product-content__image">
                <div
                  class="el-image img-main"
                  style="height: 90px; width: 90px"
                >
                  <img
                    :src="
                      currentProduct &&
                      currentProduct.skuList &&
                      `${currentProduct.skuList[0].mainPic.picUrl}?x-oss-process=image/resize,m_fill,h_100,w_100`
                    "
                    class="el-image__inner"
                    style="object-fit: cover"
                  /><!---->
                </div>
              </div>
              <div class="select-product-content__detail">
                <div style="overflow: hidden">
                  <div
                    style="width: calc(100% - 76px); float: left"
                    :title="currentProduct.proName"
                    class="title text-ellipsis"
                  >
                    {{ currentProduct.proName }}
                  </div>
                  <div
                    style="float: left"
                    @click="handleRemoveProduct"
                    class="link"
                  >
                    移除
                  </div>
                </div>
                <el-form-item v-if="false" label="颜色：">
                  <el-select
                    size="small"
                    v-model="form.color"
                    placeholder="请选择"
                    clearable
                    @change="handleChangeSku"
                  >
                    <el-option
                      v-for="item in JSON.parse(currentProduct.attribute)[
                        '颜色'
                      ]"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="false" label="尺码：">
                  <el-select
                    size="small"
                    v-model="form.size"
                    placeholder="请选择"
                    clearable
                    @change="handleChangeSku"
                  >
                    <el-option
                      v-for="item in JSON.parse(currentProduct.attribute)[
                        '尺码'
                      ]"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <el-form-item v-if="false" label="价格（￥）：">
              <el-input
                size="small"
                disabled
                v-model="currentProduct.price"
              ></el-input>
            </el-form-item>
            <el-form-item v-if="false" label="重量（g）：">
              <el-input
                size="small"
                disabled
                v-model="currentProduct.weight"
              ></el-input>
            </el-form-item>
          </div>
          <div class="item item2">
            <div class="step">
              <div class="number">2</div>
              <div>设置计算参数</div>
            </div>

            <el-form-item label="寄达国家：">
              <el-select
                clearable
                size="small"
                v-model="form.country"
                placeholder="请选择"
              >
                <el-option
                  v-for="(value, index) in dictData['amazon_site']"
                  :key="index"
                  :label="value.label"
                  :value="value.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="form.country === 'CN'" label="寄达城市：">
              <el-select
                clearable
                size="small"
                v-model="form.state"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in provinceOptions"
                  :key="item.code"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="false" label="物流：">
              <el-button @click="handleSelectShip" type="primary"
                >选择物流</el-button
              >
            </el-form-item>
            <el-form-item v-if="false" label="">
              已选择{{ shipResult.length }}物流
            </el-form-item>
          </div>
          <div class="item item3">
            <div class="step">
              <div class="number">3</div>
              <div>设置购买数量</div>
            </div>
            <el-form-item label="购买数量：">
              <el-input-number
                style="margin: 0 16px 0 0"
                v-for="(record, index) in nums"
                :key="index"
                size="small"
                v-model="nums[index]"
                :min="1"
                :max="10000"
                label="描述文字"
              ></el-input-number>
              <el-button
                @click="handleAddNum"
                size="small"
                icon="el-icon-plus"
                circle
              ></el-button>
              <el-button
                @click="handleDeleteNum"
                size="small"
                icon="el-icon-minus"
                circle
              ></el-button>
            </el-form-item>

            <div class="buttons">
              <el-button @click="handleCaculateCost" type="primary"
                >开始计算成本</el-button
              >
              <el-button @click="handleReset">重置</el-button>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <div :key="index" v-for="(detail, index) in tables">
      <div v-if="detail.opt_ship" class="search-result-wrap">
        <div class="search-result__title">
          <div>
            建议采购数量：<span>{{ detail.opt_num }}</span>
          </div>
          <div>
            建议物流：<span>{{ detail.opt_ship }}</span>
          </div>
          <div>
            最低均摊单件成本：<span>￥{{ detail.opt_unit_cost }}</span>
          </div>
          <div style="float: right">
            <span
              :id="`copyButton_${index}`"
              style="
                float: right;
                font-size: 12px;
                color: #4934b2;
                cursor: pointer;
              "
              :data-clipboard-target="`#table_${index}`"
              @click="copyText(`copyButton_${index}`)"
              >复制表格</span
            >
          </div>
        </div>
        <table :id="`table_${index}`" class="search-result__content">
          <thead>
            <tr>
              <th width="160">规格</th>
              <th width="228">物流</th>
              <th width="196">购买数量</th>
              <th width="573">产品/物流成本明细</th>
              <th width="184">总成本（¥）</th>
              <th width="232">均摊单件成本（¥）</th>
            </tr>
          </thead>
          <tbody>
            <tr :key="index" v-for="(record, index) in detail.ship">
              <td v-if="index == 0" width="160" rowspan="100">
                <span> {{ detail.spec }} </span><span></span>
              </td>
              <td
                v-if="index % record.ship_detail.length == 0"
                :rowspan="record.ship_detail.length"
                width="196"
              >
                <p>{{ record.shipping_method_name }}</p>
                <p>物流时间：{{ record.delivery_range }}个工作日</p>
              </td>
              <td width="228">
                {{ record.num }}
              </td>
              <td width="573">
                <div class="product-detail-content">
                  <div class="product-detail">
                    <span> 产品单价（¥）：{{ record.unit_price }} </span
                    ><span> 产品总价（¥）：{{ record.total_price }} </span>
                  </div>
                  <div class="product-detail">
                    <span> 估算总重（g）：{{ record.total_weight }} </span
                    ><span> 物流运费（¥）：{{ record.shipping_fee }} </span>
                  </div>
                </div>
              </td>
              <td width="184">
                {{ record.total_cost }}
              </td>
              <td width="232px">
                {{ record.unit_cost }}
              </td>
            </tr>
          </tbody>
        </table>
        <table v-if="false" class="search-result__content">
          <thead>
            <tr>
              <th width="160">规格</th>
              <th width="228">物流</th>
              <th width="196">购买数量</th>
              <th width="573">产品/物流成本明细</th>
              <th width="184">总成本（¥）</th>
              <th width="232">均摊单件成本（¥）</th>
            </tr>
          </thead>
          <tbody>
            <tr :key="index" v-for="(record, index) in detail.ship">
              <td width="160" rowspan="100">
                <span> {{ detail.spec }} </span><span></span>
              </td>
              <td width="196" rowspan="1">
                <p>联邦-美国特价</p>
                <p>物流时间：4-7个工作日</p>
              </td>
              <td width="228">9</td>
              <td width="573">
                <div class="product-detail-content">
                  <div class="product-detail">
                    <span> 产品单价（¥）：152.25 </span
                    ><span> 产品总价（¥）：1370.25 </span>
                  </div>
                  <div class="product-detail">
                    <span> 估算总重（g）：9504 </span
                    ><span>
                      物流运费（¥）：
                      <span
                        ><div
                          role="tooltip"
                          id="el-popover-9487"
                          aria-hidden="true"
                          class="el-popover el-popper"
                          tabindex="0"
                          style="width: 500px; display: none"
                        >
                          <!---->
                          <div class="popover-item popover-title">
                            联邦-美国特价
                          </div>
                          <table class="popover-table">
                            <thead>
                              <tr>
                                <th width="110">重量范围（g）</th>
                                <th>单价（¥）</th>
                                <th>附加费（¥）</th>
                                <th>服务系数</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td width="110">0-500</td>
                                <td>96.60</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">501-1000</td>
                                <td>115.50</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">1001-1500</td>
                                <td>142.80</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">1501-2000</td>
                                <td>161.70</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">2001-2500</td>
                                <td>189.00</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">2501-3000</td>
                                <td>205.38</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">3001-3500</td>
                                <td>235.20</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">3501-4000</td>
                                <td>256.62</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">4001-4500</td>
                                <td>287.70</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">4501-5000</td>
                                <td>309.12</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">5001-5500</td>
                                <td>340.20</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">5501-6000</td>
                                <td>361.62</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">6001-6500</td>
                                <td>392.70</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">6501-7000</td>
                                <td>414.12</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">7001-7500</td>
                                <td>445.20</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">7501-8000</td>
                                <td>466.62</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">8001-8500</td>
                                <td>497.70</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">8501-9000</td>
                                <td>520.38</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">9001-9500</td>
                                <td>550.20</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">9501-10000</td>
                                <td>572.88</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                            </tbody>
                          </table>
                          <div class="popover-item popover-method">
                            <div class="popover-method__left">物流费用公式</div>
                            <div class="popover-method__right">
                              <p>物流费用: 总重量对应的单价x固定附加费</p>
                              <p>572.88*1.165=667.41</p>
                            </div>
                          </div>
                        </div>
                        <span
                          class="shipping-fee el-popover__reference"
                          aria-describedby="el-popover-9487"
                          tabindex="0"
                          >667.41</span
                        ></span
                      ></span
                    >
                  </div>
                </div>
              </td>
              <td width="184">2037.66</td>
              <td width="232px">226.41</td>
            </tr>
            <tr>
              <!---->
              <td width="196" rowspan="1">
                <p>联邦</p>
                <p>物流时间：4-7个工作日</p>
              </td>
              <td width="228">9</td>
              <td width="573">
                <div class="product-detail-content">
                  <div class="product-detail">
                    <span> 产品单价（¥）：152.25 </span
                    ><span> 产品总价（¥）：1370.25 </span>
                  </div>
                  <div class="product-detail">
                    <span> 估算总重（g）：9504 </span
                    ><span>
                      物流运费（¥）：
                      <span
                        ><div
                          role="tooltip"
                          id="el-popover-4446"
                          aria-hidden="true"
                          class="el-popover el-popper"
                          tabindex="0"
                          style="width: 500px; display: none"
                        >
                          <!---->
                          <div class="popover-item popover-title">联邦</div>
                          <table class="popover-table">
                            <thead>
                              <tr>
                                <th width="110">重量范围（g）</th>
                                <th>单价（¥）</th>
                                <th>附加费（¥）</th>
                                <th>服务系数</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td width="110">0-500</td>
                                <td>122.33</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">501-1000</td>
                                <td>143.47</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">1001-1500</td>
                                <td>163.54</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">1501-2000</td>
                                <td>183.37</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">2001-2500</td>
                                <td>199.60</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">2501-3000</td>
                                <td>228.90</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">3001-3500</td>
                                <td>258.22</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">3501-4000</td>
                                <td>286.76</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">4001-4500</td>
                                <td>316.01</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">4501-5000</td>
                                <td>345.25</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">5001-5500</td>
                                <td>394.36</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">5501-6000</td>
                                <td>425.89</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">6001-6500</td>
                                <td>457.42</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">6501-700</td>
                                <td>488.95</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">7001-7500</td>
                                <td>520.49</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">7501-8000</td>
                                <td>588.54</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">8001-8500</td>
                                <td>622.13</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">8501-9000</td>
                                <td>655.72</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">9001-9500</td>
                                <td>689.32</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td width="110">9501-10000</td>
                                <td>722.90</td>
                                <td>1.165</td>
                                <td>1</td>
                              </tr>
                            </tbody>
                          </table>
                          <div class="popover-item popover-method">
                            <div class="popover-method__left">物流费用公式</div>
                            <div class="popover-method__right">
                              <p>物流费用: 总重量对应的单价x固定附加费</p>
                              <p>722.90*1.165=842.18</p>
                            </div>
                          </div>
                        </div>
                        <span
                          class="shipping-fee el-popover__reference"
                          aria-describedby="el-popover-4446"
                          tabindex="0"
                          >842.18</span
                        ></span
                      ></span
                    >
                  </div>
                </div>
              </td>
              <td width="184">2212.43</td>
              <td width="232px">245.83</td>
            </tr>
            <tr>
              <!---->
              <td width="196" rowspan="1">
                <p>顺丰国际电商专递-CD</p>
                <p>物流时间：5-15个工作日</p>
              </td>
              <td width="228">9</td>
              <td width="573">
                <div class="product-detail-content">
                  <div class="product-detail">
                    <span> 产品单价（¥）：152.25 </span
                    ><span> 产品总价（¥）：1370.25 </span>
                  </div>
                  <div class="product-detail">
                    <span> 估算总重（g）：9504 </span
                    ><span>
                      物流运费（¥）：
                      <span
                        ><div
                          role="tooltip"
                          id="el-popover-5244"
                          aria-hidden="true"
                          class="el-popover el-popper"
                          tabindex="0"
                          style="width: 500px; display: none"
                        >
                          <!---->
                          <div class="popover-item popover-title">
                            顺丰国际电商专递-CD
                          </div>
                          <table class="popover-table">
                            <thead>
                              <tr>
                                <th width="110">重量范围（g）</th>
                                <th>单价（¥）</th>
                                <th>附加费（¥）</th>
                                <th>服务系数</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td width="110">700-30000</td>
                                <td>0.09</td>
                                <td>9</td>
                                <td>1</td>
                              </tr>
                            </tbody>
                          </table>
                          <div class="popover-item popover-method">
                            <div class="popover-method__left">物流费用公式</div>
                            <div class="popover-method__right">
                              <p>
                                物流费用: 总重量 x 总重量对应的单价 + 固定附加费
                              </p>
                              <p>9504 * 0.09 + 9=864.36</p>
                            </div>
                          </div>
                        </div>
                        <span
                          class="shipping-fee el-popover__reference"
                          aria-describedby="el-popover-5244"
                          tabindex="0"
                          >864.36</span
                        ></span
                      ></span
                    >
                  </div>
                </div>
              </td>
              <td width="184">2234.61</td>
              <td width="232px">248.29</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      class="product-dialog"
      title="选择产品"
      width="900px"
      :visible.sync="editVisible"
    >
      <div>
        <el-tabs @tab-click="handleChangeTab" v-model="activeIndex">
          <el-tab-pane label="定制信息" name="1">
            <div style="margin: 8px 0">
              <el-input
                v-model="queryParams.proName"
                size="small"
                type="text"
                autocomplete="off"
                placeholder="请搜索底板名称"
                style="width: 200px; margin: 0 16px 0 0"
              ></el-input>
              <TreeSelect
                :props="treeSelectProps"
                :options="productTypeList"
                v-model="queryParams.typeId"
                placeholder="请选择分类"
                ref="childSelTree"
                @getValue="getTreeNodeId"
                style="width: 200px; margin: 0 16px 0 0"
              ></TreeSelect>
              <el-button size="small" type="primary" @click="getList"
                >搜 索</el-button
              >
            </div>
            <div class="select-product-title">产品信息</div>
            <ul class="select-product-content">
              <li
                onmouseover="setBackground(this,'#e6f5fe')"
                onmouseout="setBackground(this,'#ffffff')"
                @click="handleConfirmProduct(record)"
                v-for="(record, index) in productList"
                :key="index"
                class="select-product-item"
              >
                <div style="float: left; padding: 8px">
                  <div
                    class="el-image product-img"
                    style="height: 120px; width: 120px"
                  >
                    <img
                      :src="
                        record.skuList &&
                        `${record.skuList[0].mainPic.picUrl}?x-oss-process=image/resize,m_fill,h_200,w_200`
                      "
                      class="el-image__inner"
                      style="object-fit: cover"
                    /><!---->
                  </div>
                </div>
                <div style="float: left; width: calc(100% - 165px)">
                  <h3 class="product-name">
                    {{ record.proName }}
                  </h3>
                  <p class="product-color">
                    颜色：
                    <span
                      :key="index"
                      v-for="(product, index) in JSON.parse(record.attribute)[
                        '颜色'
                      ]"
                    >
                      {{ product
                      }}<i
                        v-if="
                          index !==
                          JSON.parse(record.attribute)['颜色'].length - 1
                        "
                        >、</i
                      ></span
                    >
                  </p>
                  <p class="product-size">
                    尺码：
                    <span
                      :key="index"
                      v-for="(product, index) in JSON.parse(record.attribute)[
                        '尺码'
                      ]"
                    >
                      {{ product
                      }}<i
                        v-if="
                          index !==
                          JSON.parse(record.attribute)['尺码'].length - 1
                        "
                        >、</i
                      ></span
                    >
                  </p>
                </div>
              </li>
            </ul>
            <pagination
              v-show="total1 > 0"
              :total="total1"
              :page.sync="queryParams.pageNum"
              :limit.sync="queryParams.pageSize"
              @pagination="getList"
            />
          </el-tab-pane>
          <el-tab-pane label="我的设计" name="2">
            <div style="margin: 8px 0">
              <el-input
                v-model="queryParams.proName"
                size="small"
                type="text"
                autocomplete="off"
                placeholder="请搜索成品名称"
                style="width: 200px; margin: 0 16px 0 0"
              ></el-input>
              <el-input
                v-model="queryParams.designId"
                size="small"
                type="text"
                autocomplete="off"
                placeholder="请搜索成品编号"
                style="width: 200px; margin: 0 16px 0 0"
              ></el-input>
              <el-button size="small" type="primary" @click="getList"
                >搜 索</el-button
              >
            </div>
            <div class="select-product-title">成品信息</div>
            <ul class="select-product-content">
              <li
                onmouseover="setBackground(this,'#e6f5fe')"
                onmouseout="setBackground(this,'#ffffff')"
                @click="handleConfirmProduct(record)"
                v-for="(record, index) in productList"
                :key="index"
                class="select-product-item"
              >
                <div style="float: left; padding: 8px">
                  <div
                    class="el-image product-img"
                    style="height: 120px; width: 120px"
                  >
                    <img
                      :src="
                        record.skuList &&
                        `${record.skuList[0].mainPic.picUrl}?x-oss-process=image/resize,m_fill,h_200,w_200`
                      "
                      class="el-image__inner"
                      style="object-fit: cover"
                    /><!---->
                  </div>
                </div>
                <div style="width: calc(100% - 165px); float: left">
                  <h3 class="product-name">
                    {{ record.proName }}
                  </h3>
                  <p class="product-color">
                    颜色：
                    <span
                      :key="index"
                      v-for="(product, index) in JSON.parse(record.attribute)[
                        '颜色'
                      ]"
                    >
                      {{ product
                      }}<i
                        v-if="
                          index !==
                          JSON.parse(record.attribute)['颜色'].length - 1
                        "
                        >、</i
                      ></span
                    >
                  </p>
                  <p class="product-size">
                    尺码：
                    <span
                      :key="index"
                      v-for="(product, index) in JSON.parse(record.attribute)[
                        '尺码'
                      ]"
                    >
                      {{ product
                      }}<i
                        v-if="
                          index !==
                          JSON.parse(record.attribute)['尺码'].length - 1
                        "
                        >、</i
                      ></span
                    >
                  </p>
                </div>
              </li>
            </ul>
            <pagination
              v-show="total1 > 0"
              :total="total1"
              :page.sync="queryParams.pageNum"
              :limit.sync="queryParams.pageSize"
              @pagination="getList"
            />
          </el-tab-pane>
        </el-tabs>
      </div>
      <div slot="footer"></div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      class="product-dialog"
      title="选择物流"
      width="900px"
      :visible.sync="shipVisible"
    >
      <div>
        <el-table
          @selection-change="handleSelectionChange"
          :data="shipArray"
          border
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            prop="shipping_method_name"
            label="物流方式"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="delivery_range"
            label="物流时间（天）"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="shipping_fee"
            label="运费（一件运费）"
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer">
        <el-button @click="cancelShip" size="small">取 消</el-button>
        <el-button type="primary" @click="handleConfirmShip" size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Breadcrumb from '@/components/common/Breadcrumb'
import {mapGetters} from 'vuex'
import TreeSelect from "@/components/common/treeSelect"
import { getProductList, getShip, calculateCost, calculateByPro, getDesignList } from "@/api/order/cost"
import { getProductTypeTree } from "@/api/product/type"
import Clipboard from "clipboard"

export default {
    name: "product",
    components:{Breadcrumb,TreeSelect },
    data(){
        return {
            // 遮罩层
            form: {color: '', size: ''},
            showDetail: false,
            editVisible: false,
            activeIndex: "1",
            queryParams:{
                pageNum: 1,
                pageSize: 10,
            },
            total1: 0,
            total2: 0,
            productTypeList: [],
            productList: [],
            designList: [],
            treeSelectProps: {
              value: "typeId", // ID字段名
              label: "typeName", // 显示名称
              children: "childrenTree", // 子级字段名
            },
            currentProduct: {},
            currentSku: {},
            provinceOptions: [],
            shipArray: [],
            shipResult: [],
            shipSelection: [],
            shipVisible: false,
            detail: {},
            nums: ['1'],
            tables: []
          }
    },

    computed:{
        ...mapGetters(['nginx','dictData']),
    },
    watch:{
      editVisible(){
        if(this.editVisible){
          this.activeIndex = "1"
          this.getList(this.activeIndex)
        }
      }
    },
    created() {
      this.getProductTypeTree()
      this.loadProvData()

      //处理数据
      this.processData(this.detail)
    },
    methods:{
      async getList(){
        if(this.activeIndex == "1"){
          let result = await getProductList(this.queryParams)
          this.productList = result.rows
          this.total1 = result.total
        } else{
          let result = await getDesignList(this.queryParams)
          this.productList = result.rows
          this.total1 = result.total
        }
      },
      loadProvData() {
        $.ajax({
          url: process.env.BASE_URL + "areaData.json",
          method: "get",
          success: (res) => {
            this.provinceOptions = res["regionalDivision"]
          },
        })
      },
      cancelShip(){
        this.shipVisible = false
      },
      handleConfirmShip(){
        this.shipResult = this.shipSelection
        this.shipVisible = false
      },
      handleSelectProduct(){
        this.editVisible = true;
      },
      handleChangeSku(){
        if(this.form.color && this.form.size){
          for(let record of this.currentProduct.skuList){
            record.properVal = record.properVal.replace(/\\/g, "")
            if(record.properVal == `${this.form.color}:${this.form.size}`){
              this.currentSku = record
              break
            }
          }
        }
      },
      handleSelectionChange(array){
        this.shipSelection = array
      },
      async getProductTypeTree() {
        let result = await getProductTypeTree()
        this.productTypeList = result.data
      },
      handleConfirmProduct(record){
        this.currentProduct = record
        this.editVisible = false;
        this.showDetail = true;
        this.form =  {color: '', size: ''}
      },
      handleRemoveProduct(){
        this.showDetail = false
        this.currentProduct = {}
        this.currentSku = {}
      },
      async handleCaculateCost(){
        try {
           this.startLoading()
            let shippingMethod = []
            for(let record of this.shipResult){
              shippingMethod.push(record.shipping_method)
            }
            let params = {
              "proCode": this.currentProduct.proCode,
              "size": this.form.size,
              "country": this.form.country,
              "state":this.form.state,
              "num":this.nums.join(','),
              "shipping_method": shippingMethod.join(','),
              "color": this.form.color,
            }
            let result = await calculateByPro(params)
            this.processData(result.data)
            this.endLoading()
        } catch (error) {
          this.endLoading()
        }

      },
      copyText(node) {
        let _this = this
        console.log(node)
        let clipboard = new Clipboard("#" + node)
        clipboard.on("success", (e) => {
          this.msgSuccess("复制成功")
          e.clearSelection()
          clipboard.destroy()
        })
    },
      async handleSelectShip(){
        if(!this.currentProduct.pId){
          this.msgError('请选择产品')
          return
        }
        // if(!this.form.size){
        //   this.msgError('请选择尺码')
        //   return
        // }
        if(!this.form.country){
          this.msgError('请选择国家')
          return
        }
        if(this.form.country == 'CN' && !this.form.state){
          this.msgError('请选择省份')
          return
        }
        let params = {
          "proCode": this.currentProduct.proCode,
          "size": this.form.size,
          "country": this.form.country,
          "state":this.form.state,
        }
        let result = await getShip(params)
        this.shipArray = result.data
        this.shipVisible = true
      },
      handleChangeTab(tab){
        this.getList(tab.name)
      },
      handleChangeNum(){},
      handleSearch(){},
      getTreeNodeId(){},
      processData(data){
        for(let priceData of data){
          let ship = []
          for(let record of priceData.ship){
            for(let detail of record.ship_detail){
              let record1 = this._.clone(record)
              ship.push(Object.assign(record1,detail))
            }
          }
          priceData.ship = ship
        }
        this.tables = data
      },
      handleAddNum(){
        this.nums.push('1')
      },
      handleDeleteNum(){
        this.nums.splice(this.nums.length-1 , 1)
      },
      handleReset(){
        this.showDetail = false
        this.currentProduct = {}
        this.currentSku = {}
        this.form =  {color: '', size: ''}
        this.nums = ['1']
        this.shipResult = []
      }
    }
}
</script>

<style lang="scss" scoped>
.form-detail-content {
  display: flex;
  border: 1px solid #e6e6e6;
}
.item {
  flex: 1;
  padding: 20px;
  .step {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 18px;
    .number {
      width: 28px;
      height: 28px;
      border-radius: 13px;
      background: #4934b2;
      text-align: center;
      line-height: 26px;
      font-size: 16px;
      margin-right: 12px;
      color: #fff;
    }
  }
}
.select-product-content {
  overflow: hidden;
  .link {
    color: #4934b2;
    cursor: pointer;
  }
}
.select-product-content__image {
  margin-right: 20px;
  cursor: pointer;
  float: left;
}
.select-product-content__detail {
  width: calc(100% - 112px);
  font-size: 14px;
  font-weight: 400;
  color: #333;
  line-height: 40px;
  float: left;
}
.item1 {
  border-right: 1px solid #e6e6e6;
}
.item2 {
  border-right: 1px solid #e6e6e6;
}
.item3 {
  position: relative;
  .buttons {
    position: absolute;
    bottom: 16px;
    right: 16px;
  }
}
.select-product {
  cursor: pointer;
  width: 90px;
  height: 90px;
  background: #f7f7f7;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  font-size: 14px;
  color: grey;
  line-height: 24px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 20px;
}
.select-product i {
  font-size: 18px;
}

.search-result-wrap {
  margin-top: 32px;
  background: #ffffff;
}

.search-result-wrap .search-result__title {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  background: #ffffd7;
  border: 1px solid #e6e6e6;
  padding: 6px 12px;
  font-size: 14px;
  color: #333;
  line-height: 30px;
}

.search-result-wrap .search-result__title span {
  font-size: 16px;
  font-weight: 700;
  color: #ea0000;
  margin-right: 35px;
}

.search-result-wrap .search-result__content {
}

.search-result-wrap .search-result__content .product-detail-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  text-align: left;
}

.search-result-wrap .search-result__content .product-detail {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  line-height: 30px;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.search-result-wrap .search-result__content .shipping-fee {
  color: #3796f6;
}
.search-result-wrap thead th {
  height: 40px;
  background: #f2f2f2;
  font-size: 16px;
  color: #000;
  line-height: 40px;
  text-align: center;
  border: 1px solid #e6e6e6;
  font-weight: normal;
}

.search-result-wrap tbody td {
  text-align: center;
  border: 1px solid #e6e6e6;
  padding: 20px;
  width: 163px;
  font-size: 14px;
  color: #333;
  line-height: 24px;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
.select-product-title {
  width: 100%;
  height: 40px;
  background: #f2f2f2;
  font-size: 14px;
  font-weight: 700;
  color: #333;
  line-height: 40px;
  margin: 24px 0 8px 0;
  padding-left: 20px;
}
.select-product-content {
  width: 100%;
  .select-product-item {
    margin: 8px 0;
    padding: 8px 0;
    width: 100%;
    clear: both;
    overflow: hidden;
    cursor: pointer;
    .product-img {
      width: 120px;
      height: 120px;
      margin-right: 26px;
    }
    .product-name {
      font-size: 16px;
      font-weight: 700;
      color: #333;
      line-height: 30px;
      margin: 0;
    }
    .product-color,
    .product-size {
      font-size: 14px;
      color: grey;
      line-height: 30px;
    }
  }
  // .select-product-item :hover {
  //   background: lavender;
  // }
}
.product-dialog ::v-deep .el-dialog__body {
  height: 60vh;
  overflow-y: auto;
}
</style>
